// This component extracted from a few places in src/pages folder, due to 99% duplication.
// Suggested to reuse this component wisly in future, and if new logic needed, add new props, or extend from this component.
import React from 'react';
import { CmsIcon } from '../../containers/CmsData/CmsIcon';
import { pickColor } from '../../style/theme/utils';
import { styled, Theme } from '../../style/theme/themeModule';

interface Props {
  text: string | JSX.Element;
  icons: {
    start: string;
    end?: string;
  };
  onClick: () => void;
  disabled?: boolean;
  dataTestId?: string;
}

// TODO refactor into usage <A> tga to be accessible via Screen Reader.
export const DownloadLink = ({ icons, text, onClick, disabled, dataTestId }: Props) => (
  <Container disabled={disabled} onClick={onClick} data-testid={dataTestId}>
    <div className="icon-and-text-container">
      <StartIcon name={icons.start} size={20} />
      <Text>{text}</Text>
    </div>
    {icons.end && <EndIcon name={icons.end} size={16} />}
  </Container>
);

interface ContainerProps extends Theme {
  disabled?: boolean;
}

// Using pickColor() takes hardcoded value of color, and direct access p.theme.colors.grey consider branded value.
// TODO Research more.
// TODO - detach "disabled" logic and implement smarter extend or passing props.
// In fact padding-bottom 15px is not good, because there is css bug with re-rendering border for 1px.
// But it's needed for pages where no Tabs.

const Container = styled.div`
  padding: 15px 0px 13px 0px;
  ${(p: ContainerProps) => p.theme.media.mobile.andDown} {
    padding: 0;
  }

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: ${pickColor((c) => c.primary2)};

  ${(p: ContainerProps) =>
    p.disabled &&
    `
    pointer-events: none;
    background-color: ${p.theme.colors.white};
    color: ${p.theme.colors.primary3};
    background-color: white;

    &:hover { 
      cursor: default;
    }
    
    .icon-and-text-container * {
      color: ${p.theme.colors.grey};
    }

    .icon-and-text-container div {
      text-decoration: none;
    }
  `}

  &:hover {
    cursor: pointer;
    color: ${pickColor((c) => c.primary1)};
  }

  .icon-and-text-container {
    display: flex;
  }
`;

const StartIcon = styled(CmsIcon)`
  margin-right: 20px;
`;

const EndIcon = styled(CmsIcon)`
  color: ${pickColor((c) => c.primary1)};
`;

const Text = styled.div`
  font-size: 16px;
  font-weight: 300;
`;
